import React from "react";
import { Divider, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import BasicTable from "./Tabla";
import CodeContent from "./CodeContent";
import EndpointContent from "./EndpointContent";
import TabLenguaje from './TabLenguaje';

function createData(
    campo,
    Tipo,
    valorEjemplo,
    Descripcion
) {
    return { campo, Tipo, valorEjemplo, Descripcion };
}

const SearchProduct = () => {
    const [t] = useTranslation('global');
    const code =
        `
    curl --location 'https://wsventas-exp.rapifac.com/v0/comprobantedetalles/productos?Descripcion=gra&Sucursal=3677&PrecioConfiguracion=1&MonedaCodigo=PEN&Pagina=0'
    --header 'Authorization: bearer eyJhbGciOiJodHRwOi8vd...'
    --header 'Content-Type: application/json'
        `;
    const cCurl =
    `  
        curl --location --request GET 'https://wsventas-exp.rapifac.com/v0/comprobantedetalles/productos?Descripcion=gra&Sucursal=3677&PrecioConfiguracion=1&MonedaCodigo=PEN&Pagina=0'
        --header 'Authorization: bearer eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMDAxLzA0L3htbGRzaWctbW9...
        --header 'Content-Type: application/json'
        --data '{ ... }'
        `;
    const csRS =
    `   
        var options = new RestClientOptions("")
        {
        MaxTimeout = -1,
        };
        var client = new RestClient(options);
        var request = new RestRequest("https://wsventas-exp.rapifac.com/v0/comprobantedetalles/productos?Descripcion=gra&Sucursal=3677&PrecioConfiguracion=1&MonedaCodigo=PEN&Pagina=0", Method.Get);
        request.AddHeader("Authorization", "bearer eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMDAxLzA0L3htb...");
        request.AddHeader("Content-Type", "application/json");
        var body = @"{ ... }";
        request.AddStringBody(body, DataFormat.Json);
        RestResponse response = await client.ExecuteAsync(request);
        Console.WriteLine(response.Content);
            `;
    const javaOK =
    `        
        OkHttpClient client = new OkHttpClient().newBuilder()
        .build();
        MediaType mediaType = MediaType.parse("application/json");
        RequestBody body = RequestBody.create(mediaType, "{ ... }");
        Request request = new Request.Builder()
        .url("https://wsventas-exp.rapifac.com/v0/comprobantedetalles/productos?Descripcion=gra&Sucursal=3677&PrecioConfiguracion=1&MonedaCodigo=PEN&Pagina=0")
        .method("GET", body)
        .addHeader("Authorization", "bearer eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMDAxLzA0L3htbGRzaWctbW9y...")
        .addHeader("Content-Type", "application/json")
        .build();
        Response response = client.newCall(request).execute();
            `
    ;
    const phpHC =
    `
        <?php
        require_once 'HTTP/Request2.php';
        $request = new HTTP_Request2();
        $request->setUrl('https://wsventas-exp.rapifac.com/v0/comprobantedetalles/productos?Descripcion=gra&Sucursal=3677&PrecioConfiguracion=1&MonedaCodigo=PEN&Pagina=0');
        $request->setMethod(HTTP_Request2::METHOD_GET);
        $request->setConfig(array(
        'follow_redirects' => TRUE
        ));
        $request->setHeader(array(
        'Authorization' => 'bearer eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMDAxLzA0L3htbGRzaWctbW9yZSNobWFjLXNo...',
        'Content-Type' => 'application/json'
        ));
        $request->setBody('{ ... }');
        try {
        $response = $request->send();
        if ($response->getStatus() == 200) {
            echo $response->getBody();
        }
        else {
            echo 'Unexpected HTTP status: ' . $response->getStatus() . ' ' .
            $response->getReasonPhrase();
        }
        }
        catch(HTTP_Request2_Exception $e) {
        echo 'Error: ' . $e->getMessage();
        }
    `;
    const csHTC =
    `         
        var client = new HttpClient();
        var request = new HttpRequestMessage(HttpMethod.Get, "https://wsventas-exp.rapifac.com/v0/comprobantedetalles/productos?Descripcion=gra&Sucursal=3677&PrecioConfiguracion=1&MonedaCodigo=PEN&Pagina=0");
        request.Headers.Add("Authorization", "bearer eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMDAxLzA0L3htbGRzaWctbW9yZSNo...");
        var content = new StringContent("{ ... }", null, "application/json");
        request.Content = content;
        var response = await client.SendAsync(request);
        response.EnsureSuccessStatusCode();
        Console.WriteLine(await response.Content.ReadAsStringAsync());
        `;
    const javaUNI =
    `        
        Unirest.setTimeouts(0, 0);
        HttpResponse<String> response = Unirest.put("https://wsventas-exp.rapifac.com/v0/comprobantedetalles/productos?Descripcion=gra&Sucursal=3677&PrecioConfiguracion=1&MonedaCodigo=PEN&Pagina=0")
        .header("Authorization", "bearer eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMDAxLzA0L3htbGRzaWctbW9yZSNobWFjLXNoYTI...")
        .header("Content-Type", "application/json")
        .body("{}")
        .asString();
    
            `;
    const phpGZ =
    `     
        <?php
        $client = new Client();
        $headers = [
        'Authorization' => 'bearer eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMDAxLzA0L3htbGRzaWctbW9yZSNobWFjLXNoYTI1NiIsInR5cCI6IkpXVCJ9.',
        'Content-Type' => 'application/json'
        ];
        $body = '{}';
        $request = new Request('GET', 'https://wsventas-exp.rapifac.com/v0/comprobantedetalles/productos?Descripcion=gra&Sucursal=3677&PrecioConfiguracion=1&MonedaCodigo=PEN&Pagina=0', $headers, $body);
        $res = $client->sendAsync($request)->wait();
        echo $res->getBody();
        `;
    const codeResponse =
        `
        {
            "TotalItems": 149,
            "ItemsPorPagina": 20,
            "PaginaActual": 1,
            "TotalPaginas": 8,
            "SumaTotal": 0.0,
            "ListaItems": [
                {
                    "Codigo": "Prod0904896",
                    "CodigoCliente": "Prod0904896",
                    "Descripcion": "00 PRODUCTO GRAVADO",
                    "Stock": 321,
                    "PrecioUnitario": 11.80,
                    "MonedaCodigo": "PEN",
                    "UbicacionDescripcion": ""
                },
                {
                    "Codigo": "Prod0904738",
                    "CodigoCliente": "silvi01",
                    "Descripcion": "0001 GRAVADO COMPRAS",
                    "Stock": -133,
                    "PrecioUnitario": 180.00,
                    "MonedaCodigo": "PEN",
                    "UbicacionDescripcion": ""
                },
                .
                .
                .
            ]
        }
        `;
    const rows = [
        createData('Descripcion', "String", "gra", t('content.buscarProducto.descripcionDescrip')),
        createData('Sucursal', "Int", "3677", t('content.buscarProducto.descripcionSucursal')),
        createData('PrecioConfiguracion', "Int", "1", t('content.buscarProducto.descripcionPrecioConfiguracion')),
        createData('MonedaCodigo', "String", "PEN", t('content.buscarProducto.descripcionMonedaCodigo')),
        createData('Pagina', "Int", "0", t('content.buscarProducto.descripcionPagina'))
    ];
    return (
        <div id="searchproduct">
            <Divider sx={{ height: '70px' }} />
            <Typography variant="h3" id="buscarProducto" gutterBottom>
                {t('content.buscarProducto.titulo')}
            </Typography>
            <Typography variant="h5" gutterBottom>
                {t('content.buscarProducto.subtitulo')}
            </Typography>
            <Typography variant="body1" gutterBottom>
                {t('content.buscarProducto.descripcion')}
            </Typography>
            <Typography variant="body1" gutterBottom>
                {t('content.buscarProducto.descripcion2')}
            </Typography>
            <EndpointContent method={'GET'} path='https://wsventas-exp.rapifac.com/v0/comprobantedetalles/productos'/>
            {/*<CodeContent code={code} />*/}
            <TabLenguaje curl={cCurl} csRS={csRS} javaOK={javaOK} phpRQ={phpHC} csHC={csHTC} java2UN={javaUNI} php2GZ={phpGZ} ></TabLenguaje>
            <br id={"respuestaBuscarProducto"}/>
            <br/>
            <br/>
            <Typography variant="h5" gutterBottom>
                {t('content.buscarProducto.subtituloRespuesta')}
            </Typography>
            <Typography variant="body1" gutterBottom>
                {t('content.buscarProducto.descripcion3')}
            </Typography>
            <CodeContent code={codeResponse} languajeCode='json' />
            <br id={"descripcionParametrosBuscarProducto"}/>
            <br/>
            <br/>
            <Typography variant="h5" gutterBottom>
                {t('content.buscarProducto.subtituloDescripcion')}
            </Typography>
            <BasicTable rows={rows} />
        </div>
    )
}
export default SearchProduct;